import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import { InferResponseType } from "hono";
import { FoldersQuery } from "./storageQueryProvider";
import { t } from "@/lib/localization";

type OriginalResponseType = InferResponseType<
    typeof client.api.storage.query.folders.$get,
    200
>;

export type GetFoldersResponseType = Omit<OriginalResponseType, "data"> & {
    data: (Omit<
        OriginalResponseType["data"][0],
        "fileCount" | "subfolderCount" | "presetId"
    > & {
        fileCount?: number;
        subfolderCount?: number;
        presetId?: string | null;
    })[];
};

export const useGetFolders = ({
    page,
    resultsPerPage,
    search,
    sortBy,
    orderBy,
    folderId,
}: FoldersQuery & { folderId?: string }) => {
    const query = useQuery({
        queryKey: [
            "get-storage-folders",
            { page, resultsPerPage, search, sortBy, orderBy, folderId },
        ],
        queryFn: async () => {
            const response = await client.api.storage.query.folders.$get({
                query: {
                    page: page.toString(),
                    resultsPerPage: resultsPerPage.toString(),
                    search,
                    sortBy,
                    orderBy,
                    folderId,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch folders");
            }

            const { data, total } = await response.json();
            return { data, total };
        },
    });

    return query;
};
